module.exports = __webpack_public_path__ + "img/20171229_1721031.922808c3.jpg";